export function isSSR() {
  return typeof window === 'undefined' || window === undefined;
}

export function getAppRoot() {
  if (!isSSR()) {
    return document.getElementById('root');
  }
}
